import React, { useEffect } from "react";
import useGenrateReport from "./useGenrateReport";
import { Button, CircularProgress, Alert } from "@mui/material";

const GenerateNow = ({ courseState, courseFilter, columnsWithIds }) => {
  const { handleSubmit, isLoading, isError, errorMsg, clearError } =
    useGenrateReport({
      columnsWithIds,
    });

  useEffect(() => {
    let hasError = false;
    for (const item of columnsWithIds) {
      if (item.type === "date_range") {
        const key = item.label.replace(/\s+/g, "_").toLowerCase();
        if (
          !(key in courseState) ||
          !courseState[key].min ||
          !courseState[key].max
        ) {
          hasError = true;
          break;
        }
      }
    }
    if (!hasError) {
      clearError();
    }
  }, [courseState, columnsWithIds, clearError]);

  return (
    <>
      {isError && errorMsg.length > 0 && (
        <Alert severity="error" sx={{ color: "black", marginBottom: "10px" }}>
          {errorMsg[0]}
        </Alert>
      )}
      <Button
        onClick={() => handleSubmit({ courseState, courseFilter })}
        disabled={isLoading}
        style={{ position: "relative" }}
      >
        {isLoading && (
          <CircularProgress
            size={24}
            color="inherit"
            style={{
              position: "absolute",
              top: "50%",
              right: "14px",
              marginTop: -12,
              marginLeft: -12,
            }}
          />
        )}
        Generate Now
      </Button>
    </>
  );
};
export default GenerateNow;
